import React from 'react';

import Button from 'components/Button/Button';
import { App } from 'generated/graphql';

interface ComponentProps {
  apps: App[];
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const OptionsAvailabilityUnsupportedAppWarning: React.FC<ComponentProps> = ({ apps, styles, closeModal }) => {
  const [title, body] = [
    'Setting options as unavailable is only accepted by some apps',
    `For now your options will remain available in ${apps.map((app) => app.name).join(', ')}.`
  ];

  return (
    <div
      data-testid="option-availability-warning-confirm"
      role="dialog"
      aria-labelledby="option-availability-unsupported-app-warning-confirm-title"
      aria-describedby="option-availability-unsupported-app-warning-confirm-description"
    >
      <i className={`mm-error-circle ${styles.UnsupportedIcon}`} />
      <h2 id="option-availability-warning-title" className={styles.NoMargin}>
        {title}
      </h2>
      <p
        id="option-availability-warning-description"
        data-testid="option-availability-warning-confirm-copy"
        style={{ whiteSpace: 'pre-wrap' }}
      >
        {body}
      </p>
      <div className={`${styles.ButtonRow} ${styles.Single}`}>
        <Button
          onClick={() => {
            closeModal();
          }}
        >
          Ok, got it
        </Button>
      </div>
    </div>
  );
};

export default OptionsAvailabilityUnsupportedAppWarning;
